import React from "react";
import { Outlet } from "react-router-dom";
import { Box, Drawer } from "@mui/material";
import DashboardSidebar from "./dashboard/DashboardSidebar";

const drawerWidth = 280;

const DashboardLayout = () => {
  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "background.default" }}>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          borderRadius: 0,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
            borderRight: "1px solid",
            borderColor: "divider",
            bgcolor: "background.paper",
            borderRadius: 0,
          },
          zIndex: (theme) => theme.zIndex.drawer - 2,
        }}
      >
        <DashboardSidebar />
      </Drawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          px: { xs: 2, md: 3.5 },
          py: { xs: 2, md: 3 },
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 1440,
            mx: "auto",
            "& > .MuiPaper-root": {
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              boxShadow: "0 18px 40px rgba(15, 23, 42, 0.04)",
              overflow: "hidden",
              p: { xs: 2, md: 3 },
            },
            "& .MuiTableContainer-root": {
              borderRadius: 1.5,
              border: "1px solid",
              borderColor: "divider",
            },
            "& .MuiTableHead-root .MuiTableCell-root": {
              bgcolor: "grey.50",
              color: "text.secondary",
              fontSize: 12,
              fontWeight: 700,
              textTransform: "uppercase",
            },
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
